/* ============================================================
   スクロール出現アニメーション（汎用）

   使い方:
     単体   … 出したい要素に class="js-reveal"
     まとめ … 親に class="js-reveal-group"、中の出したい要素に class="js-reveal"
              （親が画面に入った時点で中身がまとめて出る）
     ずらす … style="--reveal-delay: 120ms" で個別に遅延を足せる

   画面に入ったら .is-shown を付け、その要素の監視は外す（戻さない＝出し切り）。
   見え方は style.css の .js-reveal 側に持たせてある。

   発火位置は PC と SP で変える（2026-08-09 指示）:
     PC（1024px以上）… 要素の上端が画面の高さの95%より上に来たら。
                        画面に入りかけた時点で動き出し、スクロールに素直について来る。
                        読み込み直後に画面内へ収まっている要素も出せる
     SP（1024px未満）… 画面の上下20%を除いた中央60%に入ったら。
                        SPは1カラムで要素が画面いっぱいに近く、95%判定だと
                        画面の隅に掛かった時点で出てしまい早すぎるため
   ============================================================ */
(function () {
  'use strict';
  /* 同じスクリプトを複数セクションが読み込むため <script> は何本も出力される。
     ブラウザはタグごとに実行するので、ガードが無いと処理が重複する
     （アコーディオンなら開閉が複数回走り、偶数回で閉じたままになる）。 */
  if (window.mdlLpRevealReady) return;
  window.mdlLpRevealReady = true;


  var ITEM  = '.js-reveal';
  var GROUP = '.js-reveal-group';

  /* 出したあとは --reveal-delay を消す。
     横並びの時間差用に入れた遅延が transition-delay として残っていると、
     そのあとのホバー等のトランジションまで遅れて反応するため。
     transitionend は子要素からも上がってくるので、自分の分だけ拾う */
  function clearDelayWhenDone(el) {
    el.addEventListener('transitionend', function done(e) {
      if (e.target !== el) return;
      el.style.setProperty('--reveal-delay', '0ms');
      el.removeEventListener('transitionend', done);
    });
  }

  function show(el) {
    clearDelayWhenDone(el);
    el.classList.add('is-shown');
  }

  /* 監視対象。グループの中の .js-reveal は親に任せるので個別には監視しない */
  function targets() {
    var list = [];
    document.querySelectorAll(GROUP).forEach(function (el) { list.push(el); });
    document.querySelectorAll(ITEM).forEach(function (el) {
      if (!el.closest(GROUP)) list.push(el);
    });
    return list;
  }

  /* IntersectionObserver が無い環境では隠したままにせず、最初から出す */
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll(ITEM + ',' + GROUP).forEach(show);
    return;
  }

  var pc = window.matchMedia('(min-width: 1024px)');

  function rootMargin() {
    return pc.matches ? '0px 0px -5% 0px' : '-20% 0px -20%';
  }

  var io = null;

  /* rootMargin は生成時にしか渡せないので、PC/SP をまたいだら作り直す。
     すでに出した要素は監視し直さない（出し切りのまま） */
  function observe() {
    if (io) io.disconnect();
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        show(entry.target);
        io.unobserve(entry.target);
      });
    }, { rootMargin: rootMargin() });

    targets().forEach(function (el) {
      if (!el.classList.contains('is-shown')) io.observe(el);
    });
  }

  observe();

  if (pc.addEventListener) pc.addEventListener('change', observe);
  else if (pc.addListener) pc.addListener(observe);   /* Safari 13 以前 */
})();
